export const getSessionStartTime = session => {
  var _session$startTimeMs;
  return (_session$startTimeMs = session.startTimeMs) !== null && _session$startTimeMs !== void 0 ? _session$startTimeMs : 0;
};
export const getSessionEndTime = session => getSessionStartTime(session) + session.durationMinutes * 60000;
export const getInProgressSession = (sessions, now = Date.now()) => {
  var _sessions$find;
  return (_sessions$find = sessions.find(s => getSessionStartTime(s) <= now && getSessionEndTime(s) > now)) !== null && _sessions$find !== void 0 ? _sessions$find : null;
};
export const getUpcomingSessions = (sessions, now = Date.now()) => sessions.filter(s => getSessionStartTime(s) > now).sort((a, b) => getSessionStartTime(a) - getSessionStartTime(b));
export const getPastSessions = (sessions, now = Date.now()) => sessions.filter(s => getSessionEndTime(s) <= now).sort((a, b) => getSessionStartTime(b) - getSessionStartTime(a));